import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  CHECK_LINKED_ACCOUNTS,
  GOOGLE_AUTH_API,
  INSTAGRAM_AUTH_API,
  ROOT_API_URL,
  TIKTOK_AUTH_API,
} from '../route';
import { toast } from 'react-toastify';
import WebSocketService from '../WebSocketService';
import SideBar from '../components/SideBar';
import { AnimatePresence, motion } from 'framer-motion';
import authApi from '../auth.api';
import { User } from 'lucide-react';
import LinkYoutube from '../components/link-accounts/LinkYoutube';
import LinkTiktok from '../components/link-accounts/LinkTiktok';
import LinkInstagram from '../components/link-accounts/LinkInstagram';

const LinkAccounts = () => {
  const [loggedInUserEmail, setLoggedInUserEmail] = useState('');
  const [activeMenuItem, setActiveMenuItem] = useState('Link Accounts');
  const [youtubeLinked, setYoutubeLinked] = useState(false);
  const [instagramLinked, setInstagramLinked] = useState(false);
  const [tiktokLinked, setTiktokLinked] = useState(false);
  const checkLinkedAccounts = async () => {
    const response = await authApi.post(CHECK_LINKED_ACCOUNTS, {
      platforms: ['TikTok', 'YouTube Shorts', 'Instagram'],
    });
    setLoggedInUserEmail(response.data.email);
    const linkedPlatforms = response.data.linkedPlatforms;
    setYoutubeLinked(linkedPlatforms['YouTube Shorts']);
    setTiktokLinked(linkedPlatforms['TikTok']);
    setInstagramLinked(linkedPlatforms['Instagram']);
  };
  const handleLinkYoutube = async () => {
    try {
      const response = await axios.get(
        `${GOOGLE_AUTH_API}?email=${loggedInUserEmail}`
      );
      if (response.data.status && response.data.data.url) {
        window.open(response.data.data.url, '_blank', 'noopener,noreferrer');
        // Emit event to start checking for account linking
        WebSocketService.startLinkingAccount(
          'YouTube Shorts',
          loggedInUserEmail
        );
      } else {
        toast.error(
          response.data.message || 'Registration with YouTube failed'
        );
      }
    } catch (err) {
      throw err;
    }
  };
  const handleLinkTikTok = async () => {
    try {
      const response = await axios.get(
        `${TIKTOK_AUTH_API}?email=${loggedInUserEmail}`
      );
      if (response.data.status && response.data.data.url) {
        window.open(response.data.data.url, '_blank', 'noopener,noreferrer');
        // Emit event to start checking for account linking
        WebSocketService.startLinkingAccount('TikTok', loggedInUserEmail);
      } else {
        toast.error(response.data.message || 'Registration with TikTok failed');
      }
    } catch (err) {
      throw err;
    }
  };
  const handleLinkInstagram = async () => {
    try {
      const response = await axios.get(
        `${INSTAGRAM_AUTH_API}?email=${loggedInUserEmail}`
      );
      if (response.data.status && response.data.data.url) {
        window.open(response.data.data.url, '_blank', 'noopener,noreferrer');
        // Emit event to start checking for account linking
        WebSocketService.startLinkingAccount('Instagram', loggedInUserEmail);
      } else {
        toast.error(
          response.data.message || 'Registration with Instagram failed'
        );
      }
    } catch (err) {
      throw err;
    }
  };
  const [isLinkingTikTok, setIsLinkingTikTok] = useState(false);
  useEffect(() => {
    // Initialize WebSocket connection
    WebSocketService.connect(ROOT_API_URL); // Listen for account linked event
    WebSocketService.onAccountLinked((data) => {
      if (data.platforms[0] === 'TikTok') {
        setTiktokLinked(true);
        setIsLinkingTikTok(false);
        toast.success('TikTok account linked successfully!');
      }
      if (data.platforms[0] === 'YouTube Shorts') {
        setYoutubeLinked(true);
        toast.success('YouTube account linked successfully!');
      }
      if (data.platforms[0] === 'Instagram') {
        setInstagramLinked(true);
        toast.success('Instagram account linked successfully!');
      }
    });
    // Clean up on unmount
    return () => WebSocketService.disconnect();
  }, []);
  useEffect(() => {
    checkLinkedAccounts();
  }, []);
  return (
    // template <div className='flex h-screen bg-gray-50'>

    <div className='flex flex-col md:flex-row min-h-screen bg-gray-50'>
      <SideBar
        activeMenuItem={activeMenuItem}
        setActiveMenuItem={setActiveMenuItem}
      />
      <div className='flex-1 overflow-auto p-8'>
        <AnimatePresence mode='wait'>
          <motion.div
            key={activeMenuItem}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            {/* User info header */}
            <div className='flex items-center justify-between mb-8'>
              <h2 className='text-4xl font-bold text-gray-800 tracking-tight'>
                Link Your Accounts
              </h2>
              <div className='flex items-center space-x-3 bg-white rounded-lg px-4 py-2 shadow-sm'>
                <User className='h-5 w-5 text-gray-500' />
                <div className='text-right'>
                  <p className='text-xs text-gray-500'>{loggedInUserEmail}</p>
                </div>
              </div>
            </div>
            <div className='bg-white rounded-lg shadow-sm p-6 max-w-2xl'>
              <p className='text-gray-600 mb-6'>
                Connect your YouTube and TikTok accounts to start managing your
                content
              </p>
              <div className='space-y-6'>
                <LinkYoutube
                  handleLinkYoutube={handleLinkYoutube}
                  youtubeLinked={youtubeLinked}
                />
                <LinkTiktok
                  handleLinkTikTok={handleLinkTikTok}
                  tiktokLinked={tiktokLinked}
                />
                {/*<LinkInstagram*/}
                {/*  handleLinkInstagram={handleLinkInstagram}*/}
                {/*  instagramLinked={instagramLinked}*/}
                {/*/>*/}
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default LinkAccounts;
